import { cncMiniLazyload } from '@default/scripts/modules/lazy-load/cncMiniLazyload';

/** Zpracovava lazyloading obrazku */
cncMiniLazyload();
